<template>
  <div class="body">
    <!-- 进行中的订单 -->
    <baseBreadcrumb :page="$t('message.orderInProgress')" :menu="$t('message.orderForm')" />
    <!-- 状态切换 -->
    <div class="tabs">
      <el-tabs v-model="datas.status" type="card" @tab-click="search">
        <!--  全部-->
        <!-- <el-tab-pane :label="$t('message.all')" name=""></el-tab-pane> -->
        <!--  状态-->
        <el-tab-pane v-for="(item, index) in orderStatusList" :key="index" :label="item.value"
          :name="item.key + ''"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="search">
      <div class="operationContainer">
        <div class="leftContainer">
          <!--   /订单号-->
          <div class="item">
            <el-input v-model="datas.order_sn" :placeholder="$t('message.orderNumber')" class="Container"
              onfocus="this.select()" />
          </div>
          <!-- 客户ID-->
          <div class="item">
            <el-input v-model="datas.user_id" :placeholder="$t('message.clientID')" class="Container"
              onfocus="this.select()" />
          </div>
          <!--  状态 -->
          <!-- <div class="item">
            <el-select v-model="datas.status" :placeholder="$t('message.status')" filterable clearable placeholder="状态筛选">
              <el-option v-for="item in orderStatusList" :key="item.key" :label="item.value" :value="item.key">
              </el-option>
            </el-select>
          </div> -->
          <!--人员范围-->
          <div class="item">
            <!--  人员范围-->
            <cascader @setUserList="setUserList" :org_id="datas.org_id" ref="cascader" />
          </div>
          <div class="item">
            <!--  全体人员-->
            <el-select v-model="datas.admin_id" :placeholder="$t('message.specificPersonnel')" filterable clearable>
              <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="item">
            <el-select v-model="datas.g_id" clearable filterable :placeholder="$t('message.buyer')">
              <el-option v-for="item in g" :key="item.id" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <!-- 业务 -->
          <div class="item">
            <el-select v-model="datas.y_id" clearable filterable :placeholder="$t('message.salesman')">
              <el-option v-for="item in y" :key="item.id" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <!-- 配货员 -->
          <div class="item">
            <el-select v-model="datas.p_id" clearable filterable :placeholder="$t('message.distributionMember')">
              <el-option v-for="item in p" :key="item.id" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="item">
            <el-select v-model="datas.attribute" clearable filterable placeholder="SVIP">
              <el-option :label="item.label" :value="item.value" v-for="(item) in vipList" :key="item.value">
              </el-option>
            </el-select>
          </div>
          <!-- 订单类型 -->
          <div class="item">
            <el-select v-model="datas.type" clearable filterable :placeholder="$t('message.orderType')">
              <el-option :label="item.value" :value="item.key" v-for="(item) in typeList" :key="item.key">
              </el-option>
            </el-select>
          </div>
          <div class="item">
            <!--  搜索 -->
            <el-button type="primary" @click="search">{{
              $t("message.search")
            }}</el-button>
            <!--  重置 -->
            <el-button @click="reset">{{ $t("message.reset") }}</el-button>
          </div>
        </div>
      </div>
      <!-- 分配业务，采购，配货 -->
      <div class="btns" style="padding-top: 0;">
        <!-- 删除订单 -->
        <el-button type="danger" @click="allDel" v-if="isAuth(178)" class="dark">{{
          $t("message.deleteOrder")
        }}</el-button>

        <!-- 跨组调整订单 -->
        <el-button type="success" class="primary" @click="showCrossGroupOrder" v-if="isAuth(660)">{{
          $t("message.crossGroupOrderAdjustment")
        }}</el-button>
        <!-- 调整配货 -->
        <el-button type="success" @click="showOrderAdjust_p" v-if="isAuth(479)">{{
          $t("message.adjustTheDistribution")
        }}</el-button>
        <!-- 订单调整 -->
        <el-button type="success" @click="showOrderAdjust">{{
          $t("message.orderAdjust")
        }}</el-button>

        <!--  回退待入金-->
        <!-- <el-button type="danger" @click="backToNotPay">{{
          $t("message.withdrawRemaining")
        }}</el-button> -->
      </div>
    </div>
    <div class="table">
      <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
        :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" @selection-change="handleSelectionChange"
        ref="multipleTable" @cell-click="labelSelection" size="mini" v-if="show">
        <el-table-column align="center" label="NO" prop="rowNumber" width="45">
        </el-table-column>
        <el-table-column type="selection" width="45" align="center">
        </el-table-column>
        <!--  订单号-->
        <el-table-column align="center" :label="$t('message.orderNumber')">
          <template slot-scope="scope">
            <!-- 供应商订单标识 -->
            <p v-if="scope.row.order_extend.is_supplier_order">
              <el-tag size="mini" type="primary" class="primary" effect="dark">供应商订单</el-tag>
            </p>
            <p>
              <!-- 分批付款标记 -->
              <span v-if="scope.row.part_pay_status == 1" style="vertical-align: middle;"><img
                  src="@/assets/user/stages.png" alt=""></span>
              <!-- 手机下单标记 -->
              <span v-if="scope.row.from_tool != 1" style="vertical-align: middle;"><img src="@/assets/icon/mobile.png"
                  alt="" style="width: 25px;"></span>
              <router-link :to="scope.row.status <= 40
                ? '/orderDetail?order_sn=' + scope.row.order_sn
                : 'orderPaymentDetail?order_sn=' + scope.row.order_sn
                " target="_blank">
                {{ scope.row.order_sn }}</router-link>
            </p>
            <p> <router-link
                :to="'/user/basicInformation?userID=' + scope.row.user.id + '&encryption=' + $md5(scope.row.user.id + '')"
                target="_blank" style="color:#606266 ">
                {{ scope.row.user.realname }}
              </router-link>
              <el-popover placement="top-start" trigger="hover" v-if="scope.row.children_user != null" title="子账号信息">
                <p>{{ $t('message.names') }}:{{ scope.row.children_user.children_username }}</p>
                <p>ID:{{ scope.row.children_user.id }}</p>
                <img src="@/assets/user/children_user.png" alt="" slot="reference" style="vertical-align: middle;">
              </el-popover>
              <img src="@/assets/icon/illegal.png" alt="" slot="reference" style="vertical-align: middle; width: 30px;"
                v-if="scope.row.user.user_tag != false">
            </p>
          </template>
        </el-table-column>
        <!--  操作人员-->
        <el-table-column align="center" :label="$t('message.operator')">
          <template slot-scope="scope">
            <div>
              <!-- 业务员 -->
              <p>
                {{ $t("message.salesman") }}：{{ scope.row.y_admin.realname }}
              </p>
              <!-- 配货员 -->
              <p v-if="scope.row.p_admin">
                {{ $t("message.distributionMember") }}：{{
                  scope.row.p_admin.realname
                }}
              </p>
              <!-- 采购员 -->
              <p v-if="scope.row.g_admin">
                {{ $t("message.buyer") }}：{{ scope.row.g_admin.realname }}
              </p>
            </div>
          </template>
        </el-table-column>
        <!--  状态-->
        <el-table-column align="center" :label="$t('message.status')" prop="status_name" width="100">
        </el-table-column>
        <!--  订单番数-->
        <el-table-column align="center" :label="$t('message.ordersNumber')" prop="order_detail_count" width="80">
        </el-table-column>
        <!--  订单类型-->
        <el-table-column align="center" :label="$t('message.orderType')" prop="type_name" width="80">
        </el-table-column>
        <!--  订单金额.元-->
        <el-table-column align="center" :label="$t('message.amountOfOrderYuan')" width="90"
          prop="total_amount_detail.total_amount">
        </el-table-column>
        <!--  订单提交时间-->
        <el-table-column align="center" :label="$t('message.submitTime')" prop="created_at" width="82">
        </el-table-column>
        <!-- 翻译 -->
        <el-table-column align="center" :label="$t('message.translate')" prop="order_time_node.datetime_translate"
          width="82">
        </el-table-column>
        <!-- 确认 -->
        <el-table-column align="center" :label="$t('message.confirm')" prop="order_time_node.datetime_confirm"
          width="82">
        </el-table-column>
        <!-- 报价 -->
        <el-table-column align="center" :label="$t('message.quotedPrice')" prop="order_time_node.datetime_offer"
          width="82">
        </el-table-column>

        <!-- 客户入金 -->
        <el-table-column align="center" :label="$t('message.customersIntoGold')"
          prop="order_time_node.datetime_pay_submit" width="82">
        </el-table-column>
        <!-- 财务确认入金 -->
        <el-table-column align="center" :label="$t('message.financialConfirmation')"
          prop="order_time_node.datetime_pay_confirm" width="82">
        </el-table-column>
        <!-- 采购 -->
        <el-table-column align="center" :label="$t('message.purchase')"
          prop="order_time_node.datetime_purchase_complete" width="82">
        </el-table-column>
        <!-- 财务付款 -->
        <el-table-column align="center" :label="$t('message.financialPayment')"
          prop="order_time_node.datetime_purchase_complete" width="82">
        </el-table-column>
        <!-- 签收 -->
        <!-- prop="order_time_node.datetime_pay_submit" -->
        <!-- <el-table-column align="center" :label="$t('message.signFor')" width="82">
        </el-table-column> -->
        <!-- 上架 -->
        <el-table-column align="center" :label="$t('message.hitTheShelf')" prop="order_time_node.datetime_up_complete"
          width="82">
        </el-table-column>
        <!-- 出货完了 -->
        <el-table-column align="center" :label="$t('message.shippedOut')"
          prop="order_time_node.datetime_delivery_complete" width="82">
        </el-table-column>
        <!--  下载-->
        <el-table-column align="center" :label="$t('message.orderDownload')" width="80px">
          <template slot-scope="scope">
            <a :href="baseURL + '/client.orderDetailDownload?order_sn=' + scope.row.order_sn">
              <i class="el-icon-sold-out" style="font-size: 25px;"></i></a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="paginationContainer">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
        :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>

    <!--  填写删除原因" -->
    <el-dialog :title="$t('message.enterReasonForDeletion')" :close-on-click-modal="false"
      :visible.sync="delDialogVisible" width="400px" center>
      <div class="textarea">
        <el-input type="textarea" v-model="delVal" show-word-limit resize="none" onfocus="this.select()">
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delDialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <el-button type="danger" @click="orderDelete">{{
          $t("message.delete")
        }}</el-button>
      </span>
    </el-dialog>

    <!-- 调整配货订单 -->
    <orderAdjust_p ref="orderAdjust_p" />
    <!-- 跨组订单调整 -->
    <crossGroupOrderAdjustment ref="crossGroupOrderAdjustment" />
    <!-- 订单调整 -->
    <orderAdjust ref="orderAdjust" />
  </div>
</template>
<script>
import { vipList } from '@/utlis/options'
import orderAdjust_p from './components/orderAdjust_p'
import crossGroupOrderAdjustment from './components/crossGroupOrderAdjustment'
import orderAdjust from '@/components/order/components/orderAdjust.vue'
export default {
  components: {
    orderAdjust_p,
    crossGroupOrderAdjustment,
    orderAdjust,
  },
  props: ["status"],
  data() {
    return {
      vipList,
      datas: {
        order_sn: "",
        created_at_start: "",
        created_at_end: "",
        user_id: "",
        status: "",
        org_id: "",
        work_group: "",
        admin_id: "",
        page: 1,
        pageSize: 10,
        noorderByAttribute: 1,
      },
      userList: [],
      total: 0,
      tableData: [],
      selectList: [],
      show: false,

      allotOptions: [],
      //   删除
      delDialogVisible: false,
      delVal: "",
      // 修改订单类型
      typeDialogVisible: false,
      typeData: {
        order_sn: [],
        type: "",
      },
    };
  },
  computed: {

    orderStatusList() {
      let arr = [{ key: '', value: "全部" }]
      if (this.$store.state.orderStatusList instanceof Array) {
        arr = [...arr, ...this.$store.state.orderStatusList]
      }
      return arr
    },
    typeList() {
      return this.$store.state.typeList;
    },
    g() {
      return this.$store.state.authWorkGroupAdmin.g;
    },
    y() {
      return this.$store.state.authWorkGroupAdmin.y;
    },
    p() {
      return this.$store.state.authWorkGroupAdmin.p;
    },
  },
  created() {
    if (this.$route.query.user_id) {
      this.datas.user_id = this.$route.query.user_id
    }
    this.orderList();
  },
  methods: {
    orderList() {
      this.show = false;
      this.selectList = []
      this.$api.orderApi.orderList(this.datas).then((res) => {
        this.tableData = res.data.data;
        this.total = res.data.total;
        this.show = true;
      });
    },
    // 搜索订单
    search() {
      this.datas.page = 1;
      this.orderList();
    },
    // 重置
    reset() {
      this.datas = {
        order_sn: "",
        created_at_start: "",
        created_at_end: "",
        user_id: "",
        status: "",
        org_id: "",
        work_group: "",
        admin_id: "",
        page: 1,
        pageSize: 10,
        y_id: '',
        p_id: '',
        g_id: '',
        noorderByAttribute: 1,
        attribute: '',
        type: ''
      };
      this.$refs.cascader.orgId = [];
      this.orderList();
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.orderList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.orderList();
    },
    // 整个框选择
    labelSelection(row, column) {
      if (column.className == "el-table-column--selection") {
        this.$refs.multipleTable.toggleRowSelection(row);
      }
    },
    handleSelectionChange(val) {
      this.selectList = val;
    },
    // 显示配货订单调整
    showOrderAdjust_p() {
      if (this.selectList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      this.$refs.orderAdjust_p.isP = true

      this.$refs.orderAdjust_p.allotVal = {
        order_sn_set: [],
        p_id: this.selectList.length == 1 ? this.selectList[0].p_id : "",
      }

      this.selectList.forEach((item) => {
        this.$refs.orderAdjust_p.allotVal.order_sn_set.push(item.order_sn);
      });
      this.$refs.orderAdjust_p.dialogVisible = true;
    },
    // 显示跨组订单调整
    showCrossGroupOrder() {
      if (this.selectList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      this.$refs.crossGroupOrderAdjustment.allotVal = {
        order_sn_set: [],
        g_id: "",
        p_id: "",
      };
      this.selectList.forEach((item) => {
        this.$refs.crossGroupOrderAdjustment.allotVal.order_sn_set.push(item.order_sn);
      });
      this.$refs.crossGroupOrderAdjustment.dialogVisible = true;
    },
    // 填写删除原因
    allDel() {
      this.delVal = "";
      if (this.selectList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      this.delDialogVisible = true;
    },
    // 删除订单
    orderDelete() {
      if (this.delVal == "") return false;
      let datas = {
        order_sn_set: [],
        delete_reason: this.delVal,
      };
      this.selectList.forEach((item) => {
        datas.order_sn_set.push(item.order_sn);
      });
      this.$confirm(
        this.$t("message.areYouSureToDelete"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.ok"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.orderApi.deleteOrder(datas).then((res) => {
            this.$message.success(res.msg);
            this.delDialogVisible = false;
            this.orderList();
          });
        })
        .catch(() => { });
    },
    // 退回待入金
    backToNotPay() {
      if (this.selectList.length === 0) {
        this.$message.error(this.$t("message.pleaseSelectAtLeastOne")); //请至少选中一项
        return;
      }
      if (this.selectList.length > 1) {
        this.$message.error(this.$t("message.checkAtMostOne")); //至多选中一项
        return;
      }
      this.$confirm(
        this.$t("message.whetherToReturnToGold"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          let datas = {
            order_sn_set: [],
          };
          this.selectList.forEach((item) => {
            datas.order_sn_set.push(item.order_sn);
          });
          this.$api.orderApi
            .backToWaitPay({ order_sn_set: datas.order_sn_set })
            .then((res) => {
              if (res.code !== 0) {
                this.$message.error(res.msg);
              } else {
                this.$message.success(res.msg);
                this.orderList();
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 人员范围
    setUserList(data) {
      this.userList = data.userList;
      this.datas.org_id = data.id;
      this.datas.admin_id = "";
    },
    // 显示订单类型
    // 显示订单调整
    showOrderAdjust() {
      if (this.selectList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      this.$refs.orderAdjust.allotVal = {
        order_sn_set: [],
        y_id: this.selectList.length == 1 ? this.selectList[0].y_id : "",
        g_id: this.selectList.length == 1 ? this.selectList[0].g_id : "",
        p_id: this.selectList.length == 1 ? this.selectList[0].p_id : "",
      };

      this.selectList.forEach((item) => {
        this.$refs.orderAdjust.allotVal.order_sn_set.push(item.order_sn);
        this.$refs.orderAdjust.typeData.order_sn.push(item.order_sn);
      });
      this.$refs.orderAdjust.dialogVisible = true;
    },
    // 刷新订单`
    refresh() {
      this.orderList();
    },
  },
};
</script>
<style lang='scss' scoped>
.search {
  /deep/.el-input__inner {
    width: 180px;
  }
}

.table {
  margin: 20px 0;
}

.item {
  margin-right: 20px;
  margin-bottom: 20px;
}



.operationContainer {
  display: flex;
  margin-top: 0;

  .leftContainer {
    flex: 7;
  }

  .rightContainer {
    flex: 1;
  }
}



.textarea {
  padding: 0 20px;

  /deep/.el-textarea__inner {
    height: 100px;
  }
}

a {
  color: #b4272d;

  &:hover {
    text-decoration: underline;
  }
}

.content {
  padding: 0 20px;

  /deep/.el-textarea__inner {
    height: 100px;
  }

  /deep/.el-radio {
    margin-bottom: 20px;
  }
}
</style>